import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import * as en from "./en";
import * as es from "./es";
import * as pt from "./pt";

i18n.use(initReactI18next).init({
  resources: {
    es: {
      global: es.globalTranslations,
      login: es.loginTranslations,
      settings: es.settingsTranslations,
      register: es.registerTranslations,
      dispersions: es.dispersionsTranslations,
      swaps: es.swapsTranslations,
      cryptoSwaps: es.cryptoSwapsTranslations,
      cards: es.cardsTranslations,
      cardWallets: es.cardWalletsTranslations,
      accountsWallets: es.accountsWalletsTranslations,
      confirmations: es.confirmationsTranslations,
      payments: es.paymentsTranslations,
      quoter: es.quoterTranslations,
      news: es.newsTranslations,
      users: es.usersTranslations,
      audit: es.auditTranslations,
      clients: es.clientsTranslations,
      wallets: es.walletsTranslations,
      profile: es.profileTranslations,
      payins: es.payinsTranslations,
      brebQrPay: es.brebQrPayTranslations,
      transferReceipt: es.transferReceiptTranslations,
      paymentsActivity: es.paymentsActivityTranslations,
      paymentsLedger: es.paymentsLedgerTranslations,
      payoutRescue: es.payoutRescueTranslations,
      payoutBatches: es.payoutBatchesTranslations,
      organizations: es.organizationsTranslations,
      walletTopUps: es.walletTopUpsTranslations,
      paymentIncidents: es.paymentIncidentsTranslations,
      depositClabes: es.depositClabesTranslations,
      depositCvus: es.depositCvusTranslations,
      paymentFees: es.paymentFeesTranslations,
      paymentRails: es.paymentRailsTranslations,
      paymentLimits: es.paymentLimitsTranslations,
      paymentTaxes: es.paymentTaxesTranslations,
      paymentRoutes: es.paymentRoutesTranslations,
      rateProviderUsage: es.rateProviderUsageTranslations,
      metrics: es.metricsTranslations,
      verification: es.verificationTranslations,
      notificationPreferences: es.notificationPreferencesTranslations,
    },
    pt: {
      global: pt.globalTranslations,
      login: pt.loginTranslations,
      settings: pt.settingsTranslations,
      register: pt.registerTranslations,
      dispersions: pt.dispersionsTranslations,
      swaps: pt.swapsTranslations,
      cryptoSwaps: pt.cryptoSwapsTranslations,
      cards: pt.cardsTranslations,
      cardWallets: pt.cardWalletsTranslations,
      accountsWallets: pt.accountsWalletsTranslations,
      confirmations: pt.confirmationsTranslations,
      payments: pt.paymentsTranslations,
      quoter: pt.quoterTranslations,
      news: pt.newsTranslations,
      users: pt.usersTranslations,
      audit: pt.auditTranslations,
      clients: pt.clientsTranslations,
      wallets: pt.walletsTranslations,
      profile: pt.profileTranslations,
      payins: pt.payinsTranslations,
      brebQrPay: pt.brebQrPayTranslations,
      transferReceipt: pt.transferReceiptTranslations,
      paymentsActivity: pt.paymentsActivityTranslations,
      paymentsLedger: pt.paymentsLedgerTranslations,
      payoutRescue: pt.payoutRescueTranslations,
      payoutBatches: pt.payoutBatchesTranslations,
      organizations: pt.organizationsTranslations,
      walletTopUps: pt.walletTopUpsTranslations,
      paymentIncidents: pt.paymentIncidentsTranslations,
      depositClabes: pt.depositClabesTranslations,
      depositCvus: pt.depositCvusTranslations,
      paymentFees: pt.paymentFeesTranslations,
      paymentRails: pt.paymentRailsTranslations,
      paymentLimits: pt.paymentLimitsTranslations,
      paymentTaxes: pt.paymentTaxesTranslations,
      paymentRoutes: pt.paymentRoutesTranslations,
      rateProviderUsage: pt.rateProviderUsageTranslations,
      metrics: pt.metricsTranslations,
      verification: pt.verificationTranslations,
      notificationPreferences: pt.notificationPreferencesTranslations,
    },
    en: {
      global: en.globalTranslations,
      login: en.loginTranslations,
      settings: en.settingsTranslations,
      register: en.registerTranslations,
      dispersions: en.dispersionsTranslations,
      swaps: en.swapsTranslations,
      cryptoSwaps: en.cryptoSwapsTranslations,
      cards: en.cardsTranslations,
      cardWallets: en.cardWalletsTranslations,
      accountsWallets: en.accountsWalletsTranslations,
      confirmations: en.confirmationsTranslations,
      payments: en.paymentsTranslations,
      quoter: en.quoterTranslations,
      news: en.newsTranslations,
      users: en.usersTranslations,
      audit: en.auditTranslations,
      clients: en.clientsTranslations,
      wallets: en.walletsTranslations,
      profile: en.profileTranslations,
      payins: en.payinsTranslations,
      brebQrPay: en.brebQrPayTranslations,
      transferReceipt: en.transferReceiptTranslations,
      paymentsActivity: en.paymentsActivityTranslations,
      paymentsLedger: en.paymentsLedgerTranslations,
      payoutRescue: en.payoutRescueTranslations,
      payoutBatches: en.payoutBatchesTranslations,
      organizations: en.organizationsTranslations,
      walletTopUps: en.walletTopUpsTranslations,
      paymentIncidents: en.paymentIncidentsTranslations,
      depositClabes: en.depositClabesTranslations,
      depositCvus: en.depositCvusTranslations,
      paymentFees: en.paymentFeesTranslations,
      paymentRails: en.paymentRailsTranslations,
      paymentLimits: en.paymentLimitsTranslations,
      paymentTaxes: en.paymentTaxesTranslations,
      paymentRoutes: en.paymentRoutesTranslations,
      rateProviderUsage: en.rateProviderUsageTranslations,
      metrics: en.metricsTranslations,
      verification: en.verificationTranslations,
      notificationPreferences: en.notificationPreferencesTranslations,
    },
  },
  lng: "es",
  fallbackLng: "es",
  ns: [
    "global",
    "login",
    "settings",
    "register",
    "dispersions",
    "swaps",
    "cryptoSwaps",
    "cards",
    "accountsWallets",
    "confirmations",
    "payments",
    "quoter",
    "news",
    "users",
    "audit",
    "clients",
    "wallets",
    "profile",
    "payins",
    "brebQrPay",
    "transferReceipt",
    "paymentsActivity",
    "paymentsLedger",
    "payoutRescue",
    "payoutBatches",
    "organizations",
    "walletTopUps",
    "paymentIncidents",
    "depositClabes",
    "depositCvus",
    "verification",
  ],
  defaultNS: "global",
  interpolation: {
    escapeValue: false,
  },
});

// Keep <html lang> in sync with the active language so the browser does NOT
// offer/trigger auto-translation (e.g. Google Translate). Auto-translation
// mutates text nodes outside of React, which corrupts the reconciler and
// throws "NotFoundError: Failed to execute 'insertBefore' on 'Node'".
// This module is also imported by `.storybook/preview.ts`, which is type-checked
// under the node tsconfig (no DOM lib). Reach `document` through a narrowly-typed
// `globalThis` so it compiles in both projects without pulling in DOM types.
const syncDocumentLang = (lng: string) => {
  const doc = (globalThis as { document?: { documentElement: { lang: string } } }).document;
  if (doc) {
    doc.documentElement.lang = lng;
  }
};

syncDocumentLang(i18n.language);
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
